import React from 'react';
import { faAngleUp } from '@fortawesome/free-solid-svg-icons/faAngleUp';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons/faAngleDown';

import Accordion, {
  AccordionContent,
  AccordionTitle
} from '@buyside/components/presentation/Accordion/accordionComponents';
import FilterCheckbox from '@buyside/components/presentation/Filters/FilterCheckbox/filterCheckbox';
import StickyFilter from '@buyside/components/presentation/JobApplicationIndexPage/StickyFilter/JobApplicationIndexPageStickyFilter';

import { jobVaultPostingUrl } from '@buyside/util/urlHelper';

import styles from './jobApplicationIndexPageHeaderStyles.scss';

export type PropTypes = {
  jobPostingId: string;
  resultCount: number;
  title: string;
};

const JobApplicationIndexPageHeader: React.FC<PropTypes> = ({
  jobPostingId,
  resultCount,
  title
}) => {
  return (
    <div className={styles.container}>
      <header>
        <h3>
          Applicants for <a href={jobVaultPostingUrl(jobPostingId)}>{title}</a>
        </h3>
      </header>

      <Accordion initialOpen={window.innerWidth > 768}>
        <AccordionTitle
          expandable
          expandIcon={faAngleDown}
          dataTag={'filters'}
          iconStyles={styles.accordionTitleIcon}
          collapseIcon={faAngleUp}
          titleStyles={styles.accordionTitle}
        >
          Filters
        </AccordionTitle>
        <AccordionContent>
          <StickyFilter />
        </AccordionContent>
      </Accordion>

      <footer>
        <div className={styles.subfilters}>
          <FilterCheckbox text="Only show bookmarked applicants" paramName="starred" />
          <FilterCheckbox text="Only show unrejected" paramName="unrejected" />
        </div>

        <p className={styles.sortMessage}>
          <strong>{`${resultCount} applicant${resultCount !== 1 ? 's' : ''}`}</strong> sorted by
          submission date
        </p>
      </footer>
    </div>
  );
};

export default JobApplicationIndexPageHeader;
